<ion-card>
  <ion-card-header>
    <ion-card-title>Belépés más nevében</ion-card-title>
    <ion-card-subtitle>
      Átváltás egy másik felhasználó nézetére, hogy látszódjon, mit lát – milyen menüi
      vannak, mely képernyők nyílnak meg. A saját fiókodba a felül megjelenő sávról
      tudsz egy gombbal visszatérni.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="imp-fut" *ngIf="toltodik">
      <ion-spinner name="dots"></ion-spinner> Betöltés…
    </div>

    <ng-container *ngIf="!toltodik">
      <ion-note color="danger" *ngIf="!jogosult">
        <b>A nézetváltás nem indítható.</b><br>
        {{ okMagyarazat }}<br>
        <span style="opacity:.75">
          A jogosultságot a kiszolgáló ellenőrzi, nem a képernyő – itt nincs mit beállítani.
          <span *ngIf="sajat">Azonosított felhasználó: <b>{{ sajat }}</b>.</span>
          <span *ngIf="intezmeny">Intézmény: <b>{{ intezmeny }}</b>.</span>
          <span *ngIf="tokenReszlet"><br>A kiszolgáló jelzése: <code>{{ tokenReszlet }}</code></span>
        </span>
        <!-- A leggyakoribb néma hiba: az alkalmazás az egyik azonosítási kiszolgálótól
             kapja a tokent, a háttér egy másikat vár. Ilyenkor minden token elbukik. -->
        <span *ngIf="kibocsatoElter" style="display:block;margin-top:8px">
          <b>Eltérő azonosítási kiszolgáló.</b> Az alkalmazás innen kapja a belépési tokent:
          <code>{{ sajatKibocsato }}</code>, a háttér viszont ezt várja:
          <code>{{ vartKibocsato }}</code>. Amíg a kettő nem egyezik, a kiszolgáló egyetlen
          tokent sem fogad el – ez telepítési beállítás (a háttér <code>KEYCLOAK_ISSUER</code>
          / <code>IDP_HOST</code> értéke), nem a te fiókod.
        </span>
      </ion-note>

      <ng-container *ngIf="jogosult">
        <!-- A lista hibája NEM jogosultsági hiba: a jogosultság már rendben lefutott,
             csak a felhasználólistát vagy a naplót nem sikerült betölteni. -->
        <ion-note color="danger" *ngIf="listaHiba" style="display:block;margin-bottom:10px">
          <b>A felhasználólistát nem sikerült betölteni.</b><br>
          {{ listaHiba }}<br>
          <small>A jogosultságod rendben van – ez kiszolgáló-oldali hiba.</small>
        </ion-note>

        <!-- Szándékosan az első blokk: a funkció határait tudni kell HASZNÁLAT ELŐTT. -->
        <ion-note color="medium">
          <b>Mit mutat és mit nem.</b> A nézetváltás az alkalmazás oldalán történik: a
          kiszolgáló felé továbbra is a te tokened megy, tehát a háttérben a te
          jogosultságaid érvényesek. Ez azt mutatja meg, <b>mit lát</b> a felhasználó –
          nem azt bizonyítja, hogy amit nem lát, azt el sem érné. Minden nézetváltás
          naplózódik (ki, kinek a nevében, mikortól meddig).
        </ion-note>

        <div class="imp-sor" style="margin:.8rem 0">
          <ion-input label="Keresés" labelPlacement="stacked" fill="outline"
                     placeholder="név vagy azonosító" [(ngModel)]="kereses">
            <ion-icon slot="start" name="search-outline" aria-hidden="true"></ion-icon>
          </ion-input>
          <ion-select label="Típus" labelPlacement="stacked" fill="outline" interface="popover"
                      [(ngModel)]="tipusSzuro">
            <ion-select-option *ngFor="let t of tipusok" [value]="t.id">{{ t.nev }}</ion-select-option>
          </ion-select>
        </div>

        <ion-list class="imp-lista">
          <ion-item *ngFor="let f of szurtLista">
            <ion-label class="ion-text-wrap">
              <b>{{ f.nev || f.azonosito }}</b>
              <div class="azon">{{ f.azonosito }}<span *ngIf="f.reszlet"> · {{ f.reszlet }}</span></div>
            </ion-label>
            <ion-badge slot="end" class="imp-tipus"
                       [color]="tipusa(f) === 'dolgozo' || tipusa(f) === 'munkatars' ? 'primary' : (f.tipus === 'gondviselo' ? 'tertiary' : 'success')">
              {{ tipusNevek[tipusa(f)] }}
            </ion-badge>
            <ion-button slot="end" size="small" (click)="belep(f)" [disabled]="fut">
              <ion-icon slot="start" name="enter-outline"></ion-icon>Belépés
            </ion-button>
          </ion-item>
          <ion-item *ngIf="!szurtLista.length">
            <ion-label color="medium">Nincs találat.</ion-label>
          </ion-item>
        </ion-list>
        <ion-note color="medium" *ngIf="felhasznalok.length > 300">
          A lista az első 300 találatot mutatja – szűkíts a keresővel.
        </ion-note>

        <h3>Napló</h3>
        <ion-note color="medium">
          A napló csak olvasható: a felületről nem törölhető.
        </ion-note>
        <table class="imp-naplo" style="width:100%">
          <thead>
            <tr><th>Mikor</th><th>Ki</th><th>Kinek a nevében</th><th>Meddig</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let n of naplo">
              <td>{{ n.kezdve | date:'yyyy-MM-dd HH:mm' }}</td>
              <td>{{ n.admin_nev || n.admin }}</td>
              <td>{{ n.cel_nev || n.cel }} <span class="azon">({{ tipusNevek[n.cel_tipus] }})</span></td>
              <td>{{ n.vege ? (n.vege | date:'HH:mm') : 'még nyitva' }}</td>
            </tr>
            <tr *ngIf="!naplo.length"><td colspan="4">Még nem történt nézetváltás.</td></tr>
          </tbody>
        </table>
      </ng-container>
    </ng-container>
  </ion-card-content>
</ion-card>
